import icon from "./icon.js";
import loader from "./loader.js";
import tab from './tab.js'
import datePicker from './reactDates.js'
export default {
    loader,
    icon,
    tab,
    datePicker
}